<template>
    <div>
        <form-progress/>
        <div class="nav">
            <div class="form-button" @click="$emit('back')">Precedente</div>
            <div class="form-button" @click="$emit('next')" v-if="percent<100">Successivo</div>
        </div>
    </div>
</template>
<script>
import FormProgress from "./FormProgress.vue"

export default {
    name: "form-nav",
    inject: ["formState"],
    components: {
        "form-progress": FormProgress
    },
    computed: {
        percent() {
            return (this.formState.activeField / this.formState.formLength) * 100
        }
    }
}
</script>
